(function () {
  const configElement = document.getElementById('ml-fomo-config');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }

  if (!config.enabled || !config.endpoint) return;
  if (!config.mobileEnabled && window.matchMedia('(max-width: 749px)').matches) return;
  if (isExcludedTemplate(config.excludedTemplates)) return;

  const root = document.getElementById('ml-fomo');
  if (!root) return;

  const stateKey = 'mlFomoState:v1';
  const clientKey = 'mlFomoClientId:v1';
  const maxPerSession = toInt(config.maxPerSession, 3);
  const gapMs = toInt(config.gapSeconds, 60) * 1000;
  const displayMs = toInt(config.displaySeconds, 7) * 1000;
  const firstDelayMs = toInt(config.firstDelaySeconds, 20) * 1000;
  const refreshMs = toInt(config.refreshSeconds, 90) * 1000;
  const eventMaxAgeSeconds = toInt(config.eventMaxAgeSeconds, 21600);

  let state = readState();
  let queue = [];
  let visible = false;
  let closeTimer = null;
  const clientId = getClientId();

  root.dataset.position = config.position || 'top-right';

  document.addEventListener('cart:update', handleCartUpdate);
  installCartAddFetchObserver();
  window.setTimeout(loadAndShow, firstDelayMs);

  if (refreshMs > 0) {
    window.setInterval(loadAndShow, Math.max(refreshMs, gapMs));
  }

  async function handleCartUpdate(event) {
    const detail = event.detail || {};
    const data = detail.data || {};
    if (data.didError) return;
    if (!['product-form-component', 'ml-product-fbt'].includes(data.source)) return;

    await sleep(250);

    try {
      const cart = await fetchJson('/cart.js');
      const item = findAddedItem(cart.items || [], detail);
      if (!item) return;

      await postCartItem(item);
    } catch (error) {
      // The notification module must never block cart behavior.
    }
  }

  function installCartAddFetchObserver() {
    const nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function' || nativeFetch.mlFomoWrapped) return;

    window.fetch = async function mlFomoFetch(input, init) {
      const shouldTrack = isCartAddRequest(input, init);
      const variantId = shouldTrack ? extractVariantId(input, init) : '';
      const response = await nativeFetch.apply(this, arguments);

      if (shouldTrack && response && response.ok) {
        window.setTimeout(() => handleCartAddFallback(variantId), 300);
      }

      return response;
    };

    window.fetch.mlFomoWrapped = true;
  }

  async function handleCartAddFallback(variantId) {
    try {
      const cart = await fetchJson('/cart.js');
      const item = findAddedItem(cart.items || [], {
        sourceId: variantId,
        data: { variantId },
      });
      if (item) await postCartItem(item);
    } catch (error) {
      // The notification module must never block cart behavior.
    }
  }

  async function postCartItem(item) {
    const payload = buildEventPayload(item);
    if (!payload || recentlySent(payload)) return;

    await fetch(endpointUrl('/events'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  }

  async function loadAndShow() {
    state = readState();
    if (!canShow()) return;

    try {
      const url = new URL(endpointUrl('/events'));
      url.searchParams.set('client_id', clientId);
      url.searchParams.set('limit', '8');
      url.searchParams.set('max_age_seconds', String(eventMaxAgeSeconds));

      const response = await fetchJson(url.toString());
      const events = Array.isArray(response.events) ? response.events : [];
      queue = events.filter((item) => item && item.id && !state.seen.includes(item.id));
      showNext();
    } catch (error) {
      // Fail silently if the worker is unavailable.
    }
  }

  function showNext() {
    if (!canShow() || visible) return;

    const event = queue.shift();
    if (!event) return;

    visible = true;
    root.hidden = false;
    root.replaceChildren(renderCard(event));

    window.requestAnimationFrame(() => {
      root.classList.add('is-visible');
    });

    state.shown += 1;
    state.lastShownAt = Date.now();
    state.seen = [event.id].concat(state.seen || []).slice(0, 40);
    writeState(state);

    closeTimer = window.setTimeout(() => {
      hide(false);
    }, displayMs);
  }

  function renderCard(event) {
    const card = document.createElement('a');
    card.className = 'ml-fomo__card';
    card.href = event.product_url || '/collections/all';
    card.setAttribute(
      'aria-label',
      `${config.message || "Quelqu'un vient d'ajouter"} ${event.product_title || ''} à son panier`.trim()
    );

    const imageWrap = document.createElement('span');
    imageWrap.className = 'ml-fomo__image-wrap';

    if (event.image_url) {
      const image = document.createElement('img');
      image.className = 'ml-fomo__image';
      image.src = event.image_url;
      image.alt = '';
      image.loading = 'lazy';
      imageWrap.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'ml-fomo__placeholder';
      placeholder.textContent = 'ML';
      imageWrap.appendChild(placeholder);
    }

    const content = document.createElement('span');
    content.className = 'ml-fomo__content';

    const message = document.createElement('span');
    message.className = 'ml-fomo__message';
    message.append(
      document.createTextNode(`${config.message || "Quelqu'un vient d'ajouter"} `),
      productTitleElement(event.product_title || ''),
      document.createTextNode(' à son panier')
    );

    const time = document.createElement('span');
    time.className = 'ml-fomo__time';
    time.textContent = timeAgo(event.created_at);

    content.append(message, time);

    const close = document.createElement('button');
    close.className = 'ml-fomo__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Fermer');
    close.innerHTML = '&times;';
    close.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      hide(true);
    });

    card.append(imageWrap, content, close);
    return card;
  }

  function hide(manual) {
    if (closeTimer) window.clearTimeout(closeTimer);
    closeTimer = null;
    root.classList.remove('is-visible');

    if (manual && config.closeMutesSession) {
      state.dismissed = true;
      writeState(state);
    }

    window.setTimeout(() => {
      root.hidden = true;
      root.replaceChildren();
      visible = false;
      if (!manual) {
        window.setTimeout(showNext, gapMs);
      }
    }, 190);
  }

  function canShow() {
    if (state.dismissed) return false;
    if (state.shown >= maxPerSession) return false;
    return Date.now() - state.lastShownAt >= gapMs;
  }

  function findAddedItem(items, detail) {
    const data = detail.data || {};
    const sourceId = String(detail.sourceId || '');
    const variantId = String(data.variantId || (/^\d+$/.test(sourceId) ? sourceId : ''));
    const productId = String(data.productId || '');

    if (variantId) {
      const byVariant = items.find((item) => String(item.variant_id) === variantId);
      if (byVariant) return byVariant;
    }

    if (productId) {
      const byProduct = items.find((item) => String(item.product_id) === productId);
      if (byProduct) return byProduct;
    }

    return items[0];
  }

  function isCartAddRequest(input, init) {
    const method = String(init?.method || (input instanceof Request ? input.method : 'GET') || 'GET').toUpperCase();
    if (method !== 'POST') return false;

    try {
      const rawUrl = input instanceof Request ? input.url : String(input || '');
      const url = new URL(rawUrl, window.location.origin);
      return /\/cart\/add(?:\.js)?$/.test(url.pathname);
    } catch (error) {
      return false;
    }
  }

  function extractVariantId(input, init) {
    const fromInit = variantIdFromBody(init?.body);
    if (fromInit) return fromInit;

    if (input instanceof Request) {
      try {
        const url = new URL(input.url, window.location.origin);
        return url.searchParams.get('id') || '';
      } catch (error) {
        return '';
      }
    }

    try {
      const url = new URL(String(input || ''), window.location.origin);
      return url.searchParams.get('id') || '';
    } catch (error) {
      return '';
    }
  }

  function variantIdFromBody(body) {
    if (!body) return '';

    if (body instanceof FormData || body instanceof URLSearchParams) {
      return String(body.get('id') || body.get('items[0][id]') || '');
    }

    if (typeof body !== 'string') return '';

    try {
      const parsed = JSON.parse(body);
      return String(parsed.id || parsed.items?.[0]?.id || '');
    } catch (error) {
      try {
        return new URLSearchParams(body).get('id') || '';
      } catch (nestedError) {
        return '';
      }
    }
  }

  function buildEventPayload(item) {
    const productUrl = absoluteUrl(item.url || item.product_url || '');
    const imageUrl = absoluteUrl(item.image || item.featured_image?.url || '', true);
    const title = String(item.product_title || item.title || '').trim();
    if (!title || !productUrl) return null;

    return {
      product_id: String(item.product_id || ''),
      variant_id: String(item.variant_id || item.id || ''),
      product_title: title,
      variant_title: String(item.variant_title || '').trim(),
      product_url: productUrl,
      image_url: imageUrl,
      client_id: clientId,
    };
  }

  function productTitleElement(title) {
    const element = document.createElement('span');
    element.className = 'ml-fomo__product';
    element.textContent = title;
    return element;
  }

  function timeAgo(createdAt) {
    const timestamp = Number(createdAt || 0) * 1000;
    const minutes = Math.max(1, Math.round((Date.now() - timestamp) / 60000));

    if (!Number.isFinite(minutes) || minutes <= 1) return 'il y a environ 1 minute';
    if (minutes < 60) return `il y a environ ${minutes} minutes`;

    const hours = Math.round(minutes / 60);
    if (hours <= 1) return 'il y a environ 1 heure';
    return `il y a environ ${hours} heures`;
  }

  function recentlySent(payload) {
    const key = `${payload.variant_id || payload.product_id}:${payload.product_url}`;
    const storageKey = 'mlFomoLastSent:v1';
    const now = Date.now();
    let previous = {};

    try {
      previous = JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
    } catch (error) {
      previous = {};
    }

    if (previous.key === key && now - Number(previous.at || 0) < 5000) return true;
    window.sessionStorage.setItem(storageKey, JSON.stringify({ key, at: now }));
    return false;
  }

  function endpointUrl(path) {
    let base = String(config.endpoint || '').trim().replace(/\/+$/, '');
    if (base.endsWith('/events')) base = base.slice(0, -7);
    return `${base}${path}`;
  }

  async function fetchJson(url) {
    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`Request failed: ${response.status}`);
    return response.json();
  }

  function absoluteUrl(value, optional) {
    const text = String(value || '').trim();
    if (!text) return optional ? '' : '';
    try {
      return new URL(text, window.location.origin).toString();
    } catch (error) {
      return optional ? '' : '';
    }
  }

  function readState() {
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(stateKey) || '{}');
      return {
        shown: Number(parsed.shown || 0),
        seen: Array.isArray(parsed.seen) ? parsed.seen : [],
        dismissed: Boolean(parsed.dismissed),
        lastShownAt: Number(parsed.lastShownAt || 0),
      };
    } catch (error) {
      return { shown: 0, seen: [], dismissed: false, lastShownAt: 0 };
    }
  }

  function writeState(nextState) {
    window.sessionStorage.setItem(stateKey, JSON.stringify(nextState));
  }

  function getClientId() {
    let current = window.sessionStorage.getItem(clientKey);
    if (current) return current;
    current = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
    window.sessionStorage.setItem(clientKey, current);
    return current;
  }

  function isExcludedTemplate(excludedTemplates) {
    const template = String(document.getElementById('MainContent')?.dataset.template || '').toLowerCase();
    const theme = typeof Theme !== 'undefined' ? Theme : window.Theme;
    const pageType = String(theme?.template?.name || '').toLowerCase();
    return (excludedTemplates || [])
      .map((value) => String(value).trim().toLowerCase())
      .filter(Boolean)
      .some((value) => template.includes(value) || pageType.includes(value));
  }

  function toInt(value, fallback) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function sleep(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }
})();
